import { render, staticRenderFns } from "./deanTwoColumnLayout.vue?vue&type=template&id=26c11c5e"
import script from "./deanTwoColumnLayout.vue?vue&type=script&lang=ts"
export * from "./deanTwoColumnLayout.vue?vue&type=script&lang=ts"
import style0 from "./deanTwoColumnLayout.vue?vue&type=style&index=0&id=26c11c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports